export { default } from "./NotAllowedError";
